import Layout from "@/layout";
export default {
  meta: {
    title: "销项",
    icon: "b-zz",
  },
  path: "/closed",
  component: Layout,
  children: [
    {
      path: "/ClosedTis/index",
      name: "ClosedTis",
      component: () => import("@/views/ClosedManage/ClosedTis/index.vue"),
      meta: {
        title: "销项管理",
        auth: [],
        img: "zz",
      },
    },
    // {
    //   path: "/ClosedBx/index",
    //   name: "ClosedBx",
    //   component: () => import("@/views/ClosedManage/ClosedBx/index.vue"),
    //   meta: {
    //     title: "销项管理",
    //     auth: [],
    //     img: "zz",
    //   },
    // },
  ],
};
